@if (currentLanguageIsEnglish) {
  <ul>
    <li>English</li>
    <li><a (click)="toggle($event)" href="javascript:void(0)">Français</a></li>
  </ul>
}

@if (!currentLanguageIsEnglish) {
  <ul>
    <li>Français </li>
    <li><a (click)="toggle($event)" href="javascript:void(0)">English</a></li>
  </ul>
}
